(() => {
  if (window.momenteCookieSettingsInstalled) return;
  window.momenteCookieSettingsInstalled = true;
  const purposes = ['preferences', 'analytics', 'marketing'];
  let opener;
  const getPrivacy = () => new Promise((resolve, reject) => {
    if (window.Shopify?.customerPrivacy) return resolve(window.Shopify.customerPrivacy);
    if (!window.Shopify?.loadFeatures) return reject(new Error('API unavailable'));
    const timeout = setTimeout(() => reject(new Error('API load timeout')), 15000);
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
      clearTimeout(timeout);
      if (error || !window.Shopify.customerPrivacy) reject(error || new Error('API unavailable'));
      else resolve(window.Shopify.customerPrivacy);
    });
  });
  document.addEventListener('click', async event => {
    const open = event.target.closest('.ms-cookie-open');
    if (open) {
      opener = open;
      const dialog = open.closest('.ms-legal-footer').querySelector('.ms-cookie-dialog');
      const status = dialog.querySelector('.ms-cookie-status');
      status.textContent = '';
      dialog.querySelectorAll('[data-consent]').forEach(button => button.disabled = true);
      dialog.showModal();
      try {
        const api = await getPrivacy();
        const consent = api.currentVisitorConsent();
        purposes.forEach(key => dialog.querySelector(`[name="${key}"]`).checked = consent[key] === 'yes');
        dialog.querySelectorAll('[data-consent]').forEach(button => button.disabled = false);
      } catch { status.textContent = dialog.dataset.error; }
      return;
    }
    const close = event.target.closest('[data-cookie-close]');
    if (close) { close.closest('dialog').close(); opener?.focus(); return; }
    const action = event.target.closest('[data-consent]');
    if (!action) return;
    const dialog = action.closest('dialog');
    const status = dialog.querySelector('.ms-cookie-status');
    dialog.querySelectorAll('[data-consent]').forEach(button => button.disabled = true);
    try {
      const api = await getPrivacy();
      const consent = Object.fromEntries(purposes.map(key => [key, action.dataset.consent === 'accept' || (action.dataset.consent === 'save' && dialog.querySelector(`[name="${key}"]`).checked)]));
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Consent timeout')), 10000);
        api.setTrackingConsent(consent, () => { clearTimeout(timeout); resolve(); });
      });
      purposes.forEach(key => dialog.querySelector(`[name="${key}"]`).checked = consent[key]);
      status.textContent = dialog.dataset.saved;
    } catch { status.textContent = dialog.dataset.error; }
    finally { dialog.querySelectorAll('[data-consent]').forEach(button => button.disabled = false); }
  });
})();
